// extracted by mini-css-extract-plugin
export var content = "LandingTextSection-module--content--47f42";
export var wrapper = "LandingTextSection-module--wrapper--d80a1";